import { useDispatch, useSelector, useStore } from "react-redux";
import {
	addPosition as addPositionAction,
	removePosition as removePositionAction,
	setCaptain as setCaptainAction,
	toggleActive as toggleActiveAction,
	toggleParticipant as toggleParticipantAction,
	toggleStarter as toggleStarterAction
} from "./flag-football-actions";

const useFlagFootballTeamContext = ({ team: contextTeam }) => {
	const { id } = contextTeam;

	const store = useStore();
	const dispatch = useDispatch();

	const getTeamContext = (state, teamId) => {
		return state.teamContext.teams[teamId] || {};
	};

	const useTeam = () => useSelector((state) => getTeamContext(state, id).team);

	const useStarters = () =>
		useSelector((state) => getTeamContext(state, id).starters);

	const useParticipants = () =>
		useSelector((state) => getTeamContext(state, id).participants);

	const useActivePlayers = () =>
		useSelector((state) => getTeamContext(state, id).activePlayers);

	const useCaptain = () =>
		useSelector((state) => getTeamContext(state, id).captain);

	const addPosition = (player, position) => {
		const state = store.getState();
		const teamContext = getTeamContext(state, id);
		addPositionAction(teamContext, player, position, dispatch);
	};

	const removePosition = (player, position) => {
		const state = store.getState();
		const teamContext = getTeamContext(state, id);
		removePositionAction(teamContext, player, position, dispatch);
	};

	const toggleStarter = (player) => {
		const { game } = store.getState().game;
		toggleStarterAction(game.id, id, player, dispatch);
	};

	const toggleParticipant = (player) => {
		const { game } = store.getState().game;
		toggleParticipantAction(game.id, id, player, dispatch);
	};

	const toggleActive = (player) => {
		const { game } = store.getState().game;
		toggleActiveAction(game.id, id, player, dispatch);
	};

	const setCaptain = (player) => {
		const { game } = store.getState().game;
		setCaptainAction(game.id, id, player, dispatch);
	};

	const state = {
		team: useTeam,
		starters: useStarters,
		participants: useParticipants,
		activePlayers: useActivePlayers,
		captain: useCaptain
	};

	return {
		state,
		addPosition,
		removePosition,
		toggleStarter,
		toggleParticipant,
		toggleActive,
		setCaptain
	};
};

export { useFlagFootballTeamContext };
